
const currency = 'USD'; // TODO detect currency

const formatter = new Intl.NumberFormat(undefined, {style: 'currency', currency});
export default (value) => formatter.format(value || 0);
